"use client";

import { cn } from "@/lib/utils";
import { Badge } from "@/components/ui/badge";
import type { video } from "@/api/client";
import { useTranslation } from "react-i18next";

interface VideoStatusBadgeProps extends React.HTMLAttributes<HTMLDivElement> {
  status: video.VideoStatus;
}

const statusVariants: Record<video.VideoStatus, "default" | "secondary" | "destructive" | "outline"> = {
  pending: "secondary",
  processing: "default",
  completed: "outline",
  failed: "destructive",
};

function VideoStatusBadge({ status, className, ...props }: VideoStatusBadgeProps) {
  const { t } = useTranslation();
  const variant = statusVariants[status];
  const label = t(`videoStatus.${status}`);

  return (
    <Badge
      variant={variant}
      className={cn(
        status === "processing" && "animate-pulse",
        status === "completed" && "bg-green-100 text-green-800 hover:bg-green-100",
        "2k:text-base 2k:px-3 2k:py-1",
        "4k:text-xl 4k:px-5 4k:py-2",
        className
      )}
      {...props}
    >
      {label}
    </Badge>
  );
}

export { VideoStatusBadge };
